var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSwap(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.928 16C18.1903 17.2777 17.1136 18.3265 15.817 19.0305C14.5205 19.7345 13.0544 20.0662 11.5811 19.989C10.1077 19.9118 8.68442 19.4287 7.46852 18.593C6.25262 17.7573 5.2915 16.6017 4.69141 15.2539M20.7679 18.4846L20.0385 15.3251C19.9143 14.787 19.3774 14.4514 18.8392 14.5757L15.6797 15.3051",
    stroke: "#161616",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.07142 8.00025C5.80911 6.72253 6.88577 5.6737 8.18235 4.96971C9.47894 4.26572 10.945 3.93399 12.4183 4.01121C13.8917 4.08843 15.315 4.57157 16.5309 5.40724C17.7468 6.2429 18.7079 7.39853 19.308 8.74635M3.23145 5.51561L3.96086 8.67515C4.08509 9.21328 4.62204 9.54881 5.16017 9.42457L8.31971 8.69516",
    stroke: "#161616",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwap);
export default __webpack_public_path__ + "static/media/swap.17df87cbd082314ac7d5728faf1ad6e8.svg";
export { ForwardRef as ReactComponent };